module.exports = __webpack_public_path__ + "assets/img/cutting-egde-coaching.a98cbed9.png";